module.exports = __webpack_public_path__ + "images/help/icn-faq-howto-6ba14feffc0e4cc771b0979383f96afa.png";